import { Procedure } from './types'

export const mockProcedures: Procedure[] = [
  {
    _id: '1',
    home: 'home123',
    resident: 'resident456',
    title: 'Blood Pressure Check',
    description: 'Routine blood pressure monitoring. Reading: 120/80 mmHg. Patient stable.',
    procedureDate: '2026-01-15',
    procedureTime: '09:30',
    status: 'active',
    createdBy: { _id: 'user123', name: 'Sarah Johnson' },
    updatedBy: { _id: 'user123', name: 'Sarah Johnson' },
    createdAt: '2026-01-15T09:35:00',
    updatedAt: '2026-01-15T09:35:00'
  },
  {
    _id: '2',
    home: 'home123',
    resident: 'resident456',
    title: 'Wound Dressing Change',
    description: 'Changed dressing on left leg wound. Wound healing well with no signs of infection. Applied fresh sterile dressing.',
    procedureDate: '2026-01-14',
    procedureTime: '14:00',
    status: 'active',
    createdBy: { _id: 'user123', name: 'Sarah Johnson' },
    createdAt: '2026-01-14T14:15:00'
  },
  {
    _id: '3',
    home: 'home123',
    resident: 'resident456',
    title: 'Glucose Test',
    description: 'Blood glucose level test performed. Result: 5.8 mmol/L. Within normal range.',
    procedureDate: '2026-01-13',
    procedureTime: '08:00',
    status: 'active',
    createdBy: { _id: 'user456', name: 'Michael Chen' },
    createdAt: '2026-01-13T08:10:00'
  },
  {
    _id: '4',
    home: 'home123',
    resident: 'resident456',
    title: 'Physical Therapy Session',
    description: 'Completed 30-minute physical therapy session focusing on leg strengthening exercises. Patient showed good progress and cooperation throughout.',
    procedureDate: '2026-01-12',
    procedureTime: '10:30',
    status: 'active',
    createdBy: { _id: 'user789', name: 'Emma Williams' },
    createdAt: '2026-01-12T11:00:00'
  },
  {
    _id: '5',
    home: 'home123',
    resident: 'resident456',
    title: 'Medication Review',
    description: 'Annual medication review completed. All current medications reviewed with GP. No changes required.',
    procedureDate: '2026-01-10',
    procedureTime: '11:00',
    status: 'archived',
    createdBy: { _id: 'user123', name: 'Sarah Johnson' },
    archivedBy: { _id: 'user123', name: 'Sarah Johnson' },
    createdAt: '2026-01-10T11:30:00',
    archivedAt: '2026-01-11T09:00:00'
  },
  {
    _id: '6',
    home: 'home123',
    resident: 'resident456',
    title: 'Eye Examination',
    description: 'Routine eye examination conducted by optometrist. Prescription updated for new reading glasses.',
    procedureDate: '2026-01-08',
    procedureTime: '15:30',
    status: 'archived',
    createdBy: { _id: 'user456', name: 'Michael Chen' },
    archivedBy: { _id: 'user123', name: 'Sarah Johnson' },
    createdAt: '2026-01-08T16:00:00',
    archivedAt: '2026-01-09T10:00:00'
  },
  {
    _id: '7',
    home: 'home123',
    resident: 'resident456',
    title: 'Dental Check-up',
    description: 'Regular dental examination completed. No cavities found. Teeth cleaning performed.',
    procedureDate: '2026-01-05',
    procedureTime: '13:00',
    status: 'archived',
    createdBy: { _id: 'user789', name: 'Emma Williams' },
    archivedBy: { _id: 'user456', name: 'Michael Chen' },
    createdAt: '2026-01-05T13:45:00',
    archivedAt: '2026-01-06T11:00:00'
  }
]
